export default __webpack_public_path__ + "0c857f8e8258de87358f58bf1a22598f.png";